module.exports = __webpack_public_path__ + "static/media/1.202a6b29.JPG";